import React, { useContext, useState } from "react";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import { IWalkaroundList, Walkaround, api } from "../../../logic/api";
import { WalkaroundListItem } from "./WalkaroundListItem";
import { Button } from "@mui/material";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { WalkaroundEdit } from "./WalkaroundEdit";
import NotFoundPage from "../../error/NotFoundPage";
import { useTranslation } from "react-i18next";

export const WalkaroundManager: React.FC = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (session?.current?.site?.preferences.bus_walkaround_enabled != true) {
        return <NotFoundPage title={t("walkarounds.notAvailable")} message={t("walkarounds.featureNotEnabled")} />
    }

    const [listWalkaroundsParams, setListWalkaroundsParams] = useState<IWalkaroundList>({
        includeInactive: false,
    });

    const [selectedWalkaround, setSelectedWalkaround] = useState<Walkaround | null>(null);
    const [showWalkaroundEdit, setShowWalkaroundEdit] = useState(false);

    const refreshView = () => setListWalkaroundsParams({ ...listWalkaroundsParams });

    const setActive = api.hooks.walkaround.setActive();


    return <div style={{ width: "100%", maxWidth: 1200, display: "inline-block" }}>
        <div style={{ textAlign: "left" }}>
            <div style={flex.flexRows}>
                <div style={flex.flexFill}>
                    <h2>{t("walkarounds.manageWalkarounds")}</h2>
                </div>
            </div>
            <div style={{ height: 50 }}></div>
            <PagedDataView<IWalkaroundList, Walkaround>
                apiHook={api.hooks.walkaround.list}
                parameters={listWalkaroundsParams}
                renderItem={(item) => {
                    return <WalkaroundListItem key={item.id} item={item}
                        onEdit={() => {
                            setSelectedWalkaround(item);
                            setShowWalkaroundEdit(true);
                        }}
                        onDelete={() => {
                            if (!item.id) { return }
                            setActive.send(session.current.context, {
                                active: false,
                                id: item.id
                            }, () => {
                                refreshView();
                            });
                        }}
                        onRestore={() => {
                            if (!item.id) { return }
                            setActive.send(session.current.context, {
                                active: true,
                                id: item.id
                            }, () => {
                                refreshView();
                            });

                        }}
                    ></WalkaroundListItem>
                }}

            >
                <div style={{ padding: 20, backgroundColor: "#eee" }}>
                    {t("walkarounds.noWalkarounds")}
                </div>
            </PagedDataView>

            <Button
                style={{ marginLeft: 20, marginTop: 20, width: 200 }}
                variant="contained"
                color="secondary"
                onClick={() => {
                    setSelectedWalkaround({
                        name: "",
                        abbrev: "",
                        active: true,

                    });
                    setShowWalkaroundEdit(true);
                }}>{t("walkarounds.ADDNEW")}</Button>

            <ProgressDialog status={setActive.status}></ProgressDialog>

            <ErrorDialog err={setActive.err}></ErrorDialog>


            <WalkaroundEdit
                show={showWalkaroundEdit}
                walkaround={selectedWalkaround}
                onClose={(didUpdate, wa) => {
                    if (didUpdate != true || wa == null) {
                        setShowWalkaroundEdit(false);
                    } else {
                        setSelectedWalkaround(wa);
                        setShowWalkaroundEdit(false);
                        refreshView();
                    }
                }}>
            </WalkaroundEdit>
        </div>
    </div>;
}
